import "./ArtistBanner.css";

import artistLeft from "./assets/images/artist-left.png";
import artistRight from "./assets/images/artist-right.png";

function ArtistBanner() {
  return (
    <section className="artist-banner-section">

      <div className="artist-banner">

        <img
          src={artistLeft}
          alt=""
          className="artist-left"
        />

        <div className="artist-content">
          <h2>IS THERE AN ARTIST IN YOU?</h2>

          <p>
            Register here and get a ready audience to sell your art.
          </p>
          <a
        href="https://artist.artoreal.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
          <button className="artist-btn">
            Register Now →
          </button>
          </a>
        </div>

        <img
          src={artistRight}
          alt=""
          className="artist-right"
        />

      </div>
    
    </section>
  );
}

export default ArtistBanner;